import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1730b15c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1730b15c')) {
      api.createRecord('1730b15c', component.options)
    } else {
      api.reload('1730b15c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1730b15c&", function () {
      api.rerender('1730b15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/index.vue"
export default component.exports